import React from 'react';
import styled from 'styled-components';
import { COLORS, Image, ImageEntity, Typography } from '@fupa/fupa-uikit';
import TeamEmblems from 'app/components/transferModule/teamEmblems/TeamEmblems';
import { Wrapper, TextContainer } from 'app/components/transferModule/content/transfer/commonStyles';
const StyledCaption = styled(Typography).withConfig({
  componentId: "sc-1t4m9wh-0"
})(["&&&{color:", ";text-wrap:nowrap;overflow:hidden;text-overflow:ellipsis;}"], COLORS.darkestGrey);
export default function TransferComponent(_ref) {
  let {
    transfer
  } = _ref;
  const transferDate = transfer.getTransferDate();
  return /*#__PURE__*/React.createElement(Wrapper, {
    to: transfer.getLink(),
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "TransferComponent",
    "data-sentry-source-file": "TransferComponent.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Player,
    src: transfer.getProfileImage(),
    circle: true,
    width: 56,
    height: 56,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "TransferComponent.tsx"
  }), /*#__PURE__*/React.createElement(TextContainer, {
    "data-sentry-element": "TextContainer",
    "data-sentry-source-file": "TransferComponent.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "TransferComponent.tsx"
  }, transfer.getPlayerName(), " ", transfer.getTransferEmoji()), /*#__PURE__*/React.createElement(StyledCaption, {
    variant: "caption1",
    "data-sentry-element": "StyledCaption",
    "data-sentry-source-file": "TransferComponent.tsx"
  }, transfer.getTransferDescription()), transferDate ? /*#__PURE__*/React.createElement(StyledCaption, {
    variant: "caption1"
  }, transfer.getDatePrefix(), transferDate) : null), /*#__PURE__*/React.createElement(TeamEmblems, {
    fromTeam: transfer.fromTeam,
    toTeam: transfer.toTeam,
    secondPlayingRight: transfer.isSecondPlayingRight(),
    "data-sentry-element": "TeamEmblems",
    "data-sentry-source-file": "TransferComponent.tsx"
  }));
}